import Image from '../formats/image';
import Video from '../formats/video';
import Embed from '../blots/embed';
import {sanitize} from './link';
import Gallery from './gallery';
import Editable from "../blots/editable";

class Figure extends Editable {
  constructor(scroll, domNode, value) {
    super(scroll, domNode);
    
    domNode.className = value.class || 'text-center';
    domNode.classList.remove('focus', 'inactive');
  
    if (value.dataset) {
      for (const [key, val] of Object.entries(value.dataset)) {
        domNode.setAttribute(`data-${key}`, val);
      }
    }
  
    this.domWrapper = document.createElement('div');
    this.domCaption = document.createElement('figcaption');
  
    this.domWrapper.classList.add('figure_wrapper');
    
    this.domCaption.classList.add('editable_text');
  
    this.domNode.appendChild(this.domWrapper);
    this.domNode.appendChild(this.domCursor);
    this.domNode.appendChild(this.domCaption);

    if (value.image) {
      value.images = [value.image];
    }
    if (value.video) {
      value.videos = [value.video];
    }
    if (value.embeds) {
      value.embeds = [value.embed];
    }

    let uploadData = false;
    if (value.images && value.images.length) {
      for (let imageSrc of value.images) {
        this.appendImgNode(imageSrc);
        uploadData = this.uploadData(imageSrc);
        uploadData && this.uploadFile(uploadData);
      }
    } else if (value.videos && value.videos.length) {
      for (let video of value.videos) {
        this.appendVideoNode(video.src, video.autoplay);
        uploadData = this.uploadData(video.src);
        uploadData && this.uploadFile(uploadData);
      }
    } else if (value.embeds && value.embeds.length) {
      for (let embedSrc of value.embeds) {
        this.appendIframeNode(embedSrc);
      }
    }
  
    let input = document.createElement('textarea');
    input.classList.add('editable_input');
    input.setAttribute('tabindex', '-1');
    input.setAttribute('rows', '1');
    input.setAttribute('placeholder', 'Добавить подпись');
    input.value = value.caption || '';
    this.domCaption.appendChild(input);
  }
  
  attach() {
    super.attach();
    this.domWrapper.addEventListener('click', this.handleFocus.bind(this));
    this.attachFieldEvents(this.domCaption);
  }

  appendImgNode(src) {
    let image = document.createElement('img');
    image.setAttribute('src', this.sanitize(src));
    // image.setAttribute('data-action', 'zoom');
    image.className = 'img-fluid';
    this.domWrapper.appendChild(image);
    return image;
  }

  appendVideoNode(src, autoplay) {
    let video = document.createElement('video');
    video.setAttribute('src',      this.sanitize(src));
    video.setAttribute('controls', 'controls');
    
    if (autoplay) {
      video.setAttribute('preload',  'metadata');
      video.addEventListener('loadeddata', function() {
        if (!this.mozHasAudio &&
          !(this.webkitAudioDecodedByteCount) &&
          !(this.audioTracks && this.audioTracks.length)) {
          this.setAttribute('autoplay', 'autoplay');
          this.setAttribute('loop', 'loop');
          this.setAttribute('muted', 'muted');
          this.removeAttribute('controls');
          this.play();
        }
      });
    }
    
    this.domWrapper.appendChild(video);
    return video;
  }

  appendIframeNode(src) {
    let iframe       = document.createElement('iframe');
    let iframeWrap   = document.createElement('div');
    let iframeHelper = document.createElement('div');
    iframeWrap.classList.add('iframe_wrap');
    iframeWrap.appendChild(iframeHelper);
    iframeHelper.classList.add('iframe_helper');
    iframeHelper.style.paddingTop = '56.25%';
    iframeHelper.appendChild(iframe);
    iframe.setAttribute('src',               this.sanitize(src));
    iframe.setAttribute('width',             '640');
    iframe.setAttribute('height',            '360');
    iframe.setAttribute('frameborder',       '0');
    iframe.setAttribute('allowtransparency', 'true');
    iframe.setAttribute('allowfullscreen',   true);
    iframe.setAttribute('scrolling',         'no');
    this.domWrapper.appendChild(iframeWrap);
    return iframeWrap;
  }
  
  uploadFile(file) {
    const data = {'src': 'data:' + file.type + ';base64,' + file.base64_data};
    if (data) {
      let src = this.sanitize(data.src);
      if (file.type.substr(0, 6) === 'video/') {
        let video = this.domWrapper.querySelector('video');
        video.setAttribute('src', src);
      } else {
        let image = this.domWrapper.querySelector('img');
        image.setAttribute('src', src);
      }
      // this.domWrapper.classList.remove('loading');
    }
  }
  
  uploadData(url) {
    const match = url.match(/^data:(image\/gif|image\/jpe?g|image\/png|video\/mp4);base64,(.*)$/);
    if (match) {
      return {type: match[1], base64_data: match[2]};
    }
    return false;
  }

  sanitize(url) {
    url = url.replace(location.origin, '');
    return sanitize(url, ['http', 'https', 'data']) ? url : '//:0';
  }
  
  
  //
  //
  // // формат для обращения через api
  // format(name, value) {
  //   if (name === 'class') {
  //     this.domNode.className = value;
  //   } else if (name === 'caption') {
  //     this.domNode.getElementsByTagName('FIGCAPTION')[0].innerText = value;
  //   } else if (name === 'image') {
  //     this.domNode.getElementsByTagName('IMG')[0].src = value;
  //   } else if (name === 'video') {
  //     this.domNode.getElementsByTagName('VIDEO')[0].src = value;
  //   } else if (name === 'embed') {
  //     this.domNode.getElementsByTagName('IFRAME')[0].src = value;
  //   }
  //   super.format(name, value);
  // }
  //
  // // как получить value нужного формата из готового дерева
  // static formats(domNode) {
  //   const format = {};
  //   const [captionEl] = domNode.getElementsByTagName('FIGCAPTION');
  //   const [imageEl] = domNode.getElementsByTagName('IMG');
  //   const [videoEl] = domNode.getElementsByTagName('VIDEO');
  //   const [embedEl] = domNode.getElementsByTagName('IFRAME');
  //
  //   if (domNode.className) {
  //     format.class = domNode.className;
  //   }
  //
  //   if (imageEl) {
  //     format.image = imageEl.src;
  //   }
  //
  //   if (videoEl) {
  //     format.video = videoEl.src;
  //   }
  //
  //   if (embedEl) {
  //     format.embed = embedEl.src;
  //   }
  //
  //   if (captionEl) {
  //     format.caption = captionEl.innerText;
  //   }
  //
  //   return format;
  // }
  
  static value(domNode) {
    let value = {
      caption: '',
      class: '',
      dataset: {},
      images: [],
      videos: [],
      embeds: [],
    };
    const images = domNode.querySelectorAll('img');
    const videos = domNode.querySelectorAll('video');
    const iframes = domNode.querySelectorAll('iframe');
    const figcaption = domNode.querySelector('figcaption');
    
    if (images.length) {
      for (let image of images) {
        value.images.push(image.src);
      }
    }
    
    if (videos.length) {
      for (let video of videos) {
        value.videos.push({
          src: video.src,
          autoplay: Boolean(video.autoplay)
        });
      }
    }
    
    if (iframes.length) {
      for (let iframe of iframes) {
        value.embeds.push(iframe.src);
      }
    }
    
    if (figcaption) {
      const captionField = figcaption.querySelector('input,textarea');
      if (captionField) {
        value.caption = captionField.value;
      } else {
        value.caption = figcaption.innerText;
      }
    }
    value.class = domNode.className;
    value.dataset = Object.assign({}, domNode.dataset) ;
    return value;
  }
  
  loading(isLoading) {
    this.domNode.classList.toggle('inactive', isLoading);
  }
  
  focus() {
    // this.domNode.classList.add('focus');
    this.domCaption.querySelector('textarea').focus();
    this.quill.getModule('figure').showTooltip();
  }
  
  blur() {
    // this.domNode.classList.remove('focus');
    this.quill.getModule('figure').hideTooltip();
  }
}
Figure.blotName = 'figure';
Figure.tagName = 'FIGURE';

Figure.allowedChildren = [Image, Video, Embed, Gallery];

function getFigureValueByUrl(url) {
  let value;
  
  if ((value = checkYoutube(url))) {
    return value;
  }
  
  if ((value = checkVimeo(url))) {
    return value;
  }
  // if (url.match(/^(https?):\/\/(www\.|mobile\.)?twitter\.com\/(.+)\/status\/(\d+)/i)) {
  //   return {embeds: ['/embed/twitter?url=' + encodeURIComponent(url)]};
  // }
  
  if ((value = checkBase64(url))) {
    return value;
  }
  
  if ((value = checkLink(url))) {
    return value;
  }
  
  return false;
}

function checkYoutube(url) {
  if (url.match(/^(https?):\/\/(www\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/i)) {
    let hash = url.split('v=')[1];
    if (hash.indexOf('&') > -1) {
      hash = hash.split('&')[0];
    }
    return {embeds: ['https://www.youtube.com/embed/' + encodeURIComponent(hash)]};
  }
  
  if (url.match(/^(https?):\/\/(www\.)?youtu\.be\/([a-zA-Z0-9_-]+)/i)) {
    let hash = url.split('youtu.be/')[1];
    if (hash.indexOf('?') > -1) {
      hash = hash.split('?')[0]
    }
    return {embeds: ['https://www.youtube.com/embed/' + encodeURIComponent(hash)]};
  }
  
  return false;
}

function checkVimeo(url) {
  if (url.match(/^(https?):\/\/(www\.)?vimeo\.com\/(\d+)/i)) {
    const id = url.split('vimeo.com/')[1].split('/')[0].split('?')[0].split('&')[0];
    return {embeds: ['https://player.vimeo.com/video/' + encodeURIComponent(id)]};
  }
  
  return false;
}

function checkBase64(url) {
  const match = url.match(/^data:(image\/gif|image\/jpe?g|image\/png|video\/mp4);base64,(.*)$/);
  if (match) {
    if (match[1].substr(0, 6) === 'video/') {
      return {videos: [{src: url}]};
    }
    return {images: [url]};
  }
  
  return false;
}

function checkLink(url) {
  const match = url.match(/^(https?):\/\/\S+/i);
  if (match) {
    let anchor = document.createElement('a');
    anchor.href = url;
    
    if (anchor.pathname.match(/\.(jpe?g|png|gif)$/i) || anchor.hostname === 'images.unsplash.com') {
      return {images: [url]};
    }
  
    if (anchor.pathname.match(/\.(mp4)$/i)) {
      return {videos: [{src: url}]};
    }
  }
  return false;
}

export {Figure as default, getFigureValueByUrl};
